import {
  Location,
  LocationLevel,
} from '../../graphQL/types/shared';
import { gql } from '../../graphQL/useQuery';
import {
  newGetCountryDropdownLabel,
  newGetCountryDropdownSearchString,
} from '../../Utils';

export const query = gql`
  query CountryDropdown($level: LocationLevel) {
    countryDropdown: allLocations(level: $level) {
      id
      code
      shortName
      longName
      isInCountryPages
    }
  }
`;

export interface Option {
  value: string;
  name: string;
  label: string;
  searchString: string;
}

export interface FetchedDatum {
  id: Location['id'];
  shortName: Location['shortName'];
  longName: Location['longName'];
  code: Location['code'];
  isInCountryPages: Location['isInCountryPages'];
}

export const transform = (input: FetchedDatum[]): Option[] => {
  const sorted = input.sort((a, b) => {
    const aCode = a.code;
    const bCode = b.code;
    if (aCode > bCode) {
      return 1;
    } else if (aCode < bCode) {
      return -1;
    } else {
      const aName = a.longName;
      const bName = b.longName;
      return (aName > bName) ? 1 : -1;
    }
  });
  const filtered = sorted.filter(({ isInCountryPages }) => isInCountryPages === true);
  return filtered.map(({id, shortName, code, longName}) => ({
    value: id,
    name: shortName,
    label: newGetCountryDropdownLabel(shortName, LocationLevel.country, code),
    searchString: newGetCountryDropdownSearchString(
      shortName, longName, LocationLevel.country, code,
    ),
  }));
};

export interface Variables {
  level: LocationLevel;
}

export const variables = {
  level: LocationLevel.country,
};

export interface SuccessResponse {
  countryDropdown: FetchedDatum[];
}
